/** Employee permissions granted by the admin portal backend. */
export const EmployeePermission = {
  SUPPLIERS_ACCESS: 'SUPPLIERS_ACCESS',
  APPLICATIONS_ACCESS: 'APPLICATIONS_ACCESS',
  TRANSACTIONS_ACCESS: 'TRANSACTIONS_ACCESS',
  CREDIT_PLANS_ACCESS: 'CREDIT_PLANS_ACCESS',
  USERS_ACCESS: 'USERS_ACCESS',
  TERMINATION_ACCESS: 'TERMINATION_ACCESS',
  MYSTIC_ACCESS: 'MYSTIC_ACCESS',
  PLWC_ACCESS: 'PLWC_ACCESS',
  OPE_ACCESS: 'OPE_ACCESS',
} as const;

export type EmployeePermission = (typeof EmployeePermission)[keyof typeof EmployeePermission];
